import * as actions from "./types";

export function authLoading() {
  return {
    type: actions.AUTH_LOADING
  };
}

export function authLoginStart() {
  return {
    type: actions.AUTH_LOGIN_START
  };
}

export function authLoginSuccess(token) {
  return {
    type: actions.AUTH_LOGIN_SUCCESS,
    payload: token
  };
}

export function authLoginFail(error) {
  return {
    type: actions.AUTH_LOGIN_FAIL,
    payload: error
  };
}

export function authCheck() {
  return {
    type: actions.AUTH_CHECK
  };
}

export function authGetUserStart() {
  return {
    type: actions.AUTH_GET_USER_START
  };
}
export function authGetUserSuccess(user) {
  return {
    type: actions.AUTH_GET_USER_SUCCESS,
    payload: user
  };
}
export function authGetUserFail(error) {
  return {
    type: actions.AUTH_GET_USER_FAIL,
    payload: error
  };
}

export function authLogout() {
  return {
    type: actions.AUTH_LOGOUT
  };
}



// WEBPACK FOOTER //
// ./src/system/store/auth/actions.js